module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAzUlEQVQoU92RMQrCUAyG8y+lgtDVwcHRIzg49BA6udRJKH19cXP1BObRUse6uHkIj+ENvICDUMuTJ1WKgjibJcn/5yOEgFoRx3HX87ySiC5Ottb2qqqaFkXx6F1Aa70F4DcDfl3X6zzPT65P03QMYAHg1vhXtDf8UkMp1SeiUZZlB2aeicg+SZKhg90mpdTEec8MZh4QUSgiO2YuRWTOzKEDROTY0iI383eA1jozxqi3ozcismTmz6O//eEFRFHkB0EgAM7fAGttxxizugM2cbnxQQ1zcwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/shanchu.png
// module id = bvzU
// module chunks = 96